import styled from 'styled-components'

export const Badge = styled.span`
    margin: 2px 2px;
    font-size: 12px;
    padding: 4px 10px;
    font-weight: 800;
    text-shadow: 0px 0px 2px black;
`
